import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=1d003c8b&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=1d003c8b&prod&scoped=true&lang=css"
import style1 from "./CustomerList.vue?vue&type=style&index=1&id=1d003c8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d003c8b",
  null
  
)

export default component.exports